"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskClientName = maskClientName;
function maskClientName(firstName, lastName) {
    const maskPart = (part) => {
        const trimmed = part.trim();
        if (!trimmed)
            return "";
        if (trimmed.length === 1)
            return `${trimmed[0]}***`;
        return `${trimmed[0]}***`;
    };
    const first = maskPart(firstName ?? "");
    const last = maskPart(lastName ?? "");
    if (first && last)
        return `${first} ${last}.`;
    if (first)
        return `${first}.`;
    if (last)
        return `${last}.`;
    return "—";
}
